import { navigate } from 'hookrouter'
import { useCompany } from 'hooks/useCompany'
import { useForm } from 'hooks/useForm'
import { APP_ROUTES } from 'pages/AppRouter'
import React, { FC } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { updateCompany } from 'state/async_actions'
import { useAppContext } from 'state/context'
import { CompanyIdUrlParam } from 'types'
// import { ErrorsDisplay } from '../ErrorsDisplay'

interface InputProps {
  name: string
}

export const NoCompanyText = 'No Company found that matches this company'

export const EditCompanyForm: FC<CompanyIdUrlParam> = ({ companyId }) => {
  const [, dispatch] = useAppContext()
  const company = useCompany(companyId)
  const [{ name }, handleInputChange, handleSubmit, validated] = useForm<
    InputProps
  >(inputs => {
    updateCompany(dispatch, inputs, companyId)
    navigate(APP_ROUTES.root)
  })

  const companyName = company && company.name

  const form = (
    <>
      <Row>
        <Col>
          <h1>Edit {companyName}</h1>
          {/* <ErrorsDisplay /> */}
        </Col>
      </Row>
      <Row>
        <Col>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group controlId="formBasicName">
              <Form.Label>Name</Form.Label>
              <Form.Control
                required
                onChange={handleInputChange}
                value={name || ''}
                name="name"
                type="text"
                placeholder={company && company.name}
              />
            </Form.Group>
            <Button variant="primary" value="Save Company" type="submit">
              Save
            </Button>
          </Form>
        </Col>
      </Row>
    </>
  )

  return company ? form : <h1>{NoCompanyText}</h1>
}
